export const formatDate = (date: string | number | Date) =>
  new Date(date)
    .toLocaleDateString('en-us', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    })
    .replaceAll('/', '-');
